module.exports = __webpack_public_path__ + "img/0034.172ffdbf.png";